import { DisplayPosition } from '@/common/manager/position/display-position';
import CnMessageAlc from '@/lowcode/cn-message-alc';
import isPlainObject from 'lodash/isPlainObject';
export const config = {
    position: [
        DisplayPosition.formDialog,
        DisplayPosition.form,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Message',
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formInstance } = config || {};
        if (formItem) {
            const decoratorProps = formItem?.['x-decorator-props'];
            if (isPlainObject(decoratorProps)) {
                decoratorProps.labelCol = {
                    hidden: true,
                };
            }
            const { label } = formItemConfig;
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                if (label) {
                    if (!componentProps.title) {
                        componentProps.title = label;
                    }
                }
                componentProps.getContext = () => {
                    return config?._context;
                };
                componentProps._getFormValue = () => {
                    return formInstance?.values;
                };
            }
            formItem.title = '';
        }
    },
    formComponent: CnMessageAlc,
};
